import * as THREE from "three";
import React, { useMemo, useRef } from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import path from "../path";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF(path + "/assets/hands/hand.glb");

  const albedo = useTexture(path + "/assets/hands/hand-color-blue.png");
  const metal = useTexture(path + "/assets/hands/hand-metalrough.png");

  const mat = useMemo(() => {
    albedo.flipY = false;
    metal.flipY = false;
    const mat = new THREE.MeshPhysicalMaterial({
      map: albedo,
      metalnessMap: metal,
      roughnessMap: metal,
      metalness: 1,
      roughness: 1,
    });
    mat.needsUpdate = true;
    return mat;
  }, []);

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Mao.geometry}
        // geometry={nodes.Mao_Basemesh_Merge001.geometry}
        material={mat}
        rotation={[1.21, -0.68, 2.08]}
        scale={[-1.9, 1.9, 1.9]}
      />
    </group>
  );
}

useGLTF.preload(path + "/assets/hands/hand.glb");
useTexture.preload(path + "/assets/hands/hand-color-blue.png");
useTexture.preload(path + "/assets/hands/hand-metalrough.png");
